import React from 'react';
import { Route, Outlet } from 'react-router-dom';
import { DirectInputProvider } from './DirectInputContext';
import { ExternalInputProvider } from './ExternalInputContext';
import DirectInput from './directInput';
import ExternalInput from './externalInput';
import NewProducer from './newProducer';
import { URLS } from '../../_config';

// Export all routes
export const wineAdditionRoutes = [
    // Direct input and its related routes
    <Route element={<DirectInputProvider />} key="wine-addition-provider">
        <Route
            path={URLS.WINE_ADDITION.DIRECT_INPUT.CREATE}
            element={<DirectInput />}
        />
        <Route 
            path={URLS.WINE_ADDITION.NEW_PRODUCER} 
            element={<NewProducer />}
        />
        <Route
            path={URLS.WINE_ADDITION.EDIT_WINE}
            element={<NewProducer />} 
        />
        <Route
            path={URLS.WINE_ADDITION.ADD_WINE_TO_PRODUCER}
            element={<NewProducer />}
        />
    </Route>,
    
    // External input route - we don't need the provider here anymore
    // since it's now applied at the app level
    <Route
        key="external-input-route"
        path={URLS.WINE_ADDITION.EXTERNAL_INPUT.CREATE}
        element={<ExternalInput />}
    />
];
